module.exports = __webpack_public_path__ + "static/zqb_2.5b1ed5f9.jpg";